/* eslint-disable @typescript-eslint/no-misused-promises */
import React, { memo, useState } from 'react';
import { isEmpty } from 'lodash-es';
import DefaultAnswerLoading from '../../../ChatPage/components/AnswerLoading/index'; // 修改导入名称避免冲突
import classNames from 'classnames';
import IwikiBtn from '@/pages/aigc/assets/svg/iwiki-btn.svg';
import IwikiRefresh from '@/pages/aigc/assets/svg/iwiki-refresh.svg';
import MayAsk from './components/IWikiMarkCmp';
import { useBoolean, useMemoizedFn } from 'ahooks';
import { v4 as uuidv4 } from 'uuid';
import { FEED_BACK_MESSAGES_LIST } from '../../../config/constant';
import { IWikiFeedbackPopConfirm } from './components/IWikiFeedbackPopConfirm';
import { useErrorTips } from '@/pages/aigc/hooks/useErrorTips';
import { updateHistory } from '../../../service/service';
import { useSearchParamsAppoint } from '@/pages/aigc/hooks/useQuery';
import { copyToClipboard } from '@/pages/aigc/utils/utils';
import useRefreshHooks from '../../../ChatPage/components/FeedbackOperation/useRefreshHooks';
import { message, Popover } from 'tea-component';
import { sendIWikiMessage } from '../../utils';
import { buriedBtnPoint } from '@home/utils/buriedPoint';
import { StreamingText } from '@/pages/aigc/components/StreamingText';
import { useStallByText } from '../../../ChatPage/hooks/useStallByText';

interface IWikiSingleQAProps {
  isLastQA: boolean | null;
  streamingState?: 'pending' | 'progressing' | 'complete' | 'rejected';
  AnswerLoading?: React.ComponentType;
  contentSingleQA?: (props: any) => React.ReactNode;
  question: string;
  answer?: Array<{ type: string; value: any; }> | undefined;
  messageId: string;
  userInfo: {
    openid?: string;
    [key: string]: any;
  };
  sendIWikiMessage: (config: Parameters<typeof sendIWikiMessage>[0]) => void;
  // 其他可能的props
  [key: string]: any;
}

// 单轮QA组件
export const IWikiSingleQA: React.FC<IWikiSingleQAProps> = (props) => {
  const {
    isLastQA,
    streamingState,
    AnswerLoading = DefaultAnswerLoading, // 添加默认值
    contentSingleQA,
    question,
    answer,
    sendIWikiMessage,
    messageId,
  } = props || {};
  const inViewport = document.querySelector('.dba-reference-iwiki-container-list');
  const stalled = useStallByText(answer, streamingState);
  return (
    <div className="dba-signle-qa">
      {/* TODO: 这个dom结构还需再次优化 */}
      <div className="dba-answer">
        <div className="dba-process-box">
          <div className={classNames('dba-answer-content')}>
            <div className={classNames('dba-process-iwiki',{
              'dba-process-iwiki-table': inViewport
            })}>
              <div id={`reference${messageId}-true`} />
              <div
                style={{
                  width: 'calc(100% - 280px)',
                  flex: '1',
                }}
                className="dbh-agent-iwiki"
              >
                {contentSingleQA?.({ ...props, question, answer })}
              </div>
            </div>
            {streamingState === 'progressing' && isLastQA && stalled && (
              <StreamingText
                textColor="#838697"
                streamColor="#000000"
                fontSize="14px"
                duration={1.5}
                loop
                autoPlay
              />
            )}
            {streamingState === 'pending' && isLastQA && isEmpty(answer) && <AnswerLoading />}
            {(streamingState === 'complete' || !streamingState) &&
              !isEmpty(answer) && (
              <div className={classNames('dba-answer-content-feedback')}>
                <FeedbackOperation {...props} />
              </div>
            )}
          </div>
        </div>
      </div>
      <MayAsk
        sendIWikiMessage={sendIWikiMessage}
        question={question}
        isLastQA={isLastQA}
        streamingState={streamingState}
        answer={answer}
        AnswerLoading={AnswerLoading}
      />
    </div>
  );
};

export const FeedbackOperation = memo(
  ({
    messageId,
    userInfo,
    question,
    answer,
    handleSubmit,
    conversations,
    isLastQA,
    like,
  }: Partial<IWikiSingleQAProps>) => {
    const [feedbackPopState, { setFalse: setFeedbackPopClose, setTrue }] =
      useBoolean(false);
    const { sessionId } = useSearchParamsAppoint();
    const showErrorTips = useErrorTips();
    const [likeState, setLikeState] = useState(like || 0);
    const deleteMessageIds = conversations
      ?.slice(conversations.findIndex((item) => item?.messageId === messageId))
      ?.map((conv) => conv.messageId);
    const { handleRefreshConfirm } = useRefreshHooks({
      userInfo,
      question,
      deleteMessageIds,
      handleSubmit,
    });
    const handleDislikeFeedback = useMemoizedFn((val?: any) => {
      let result = [];
      let otherParams;
      if (!isEmpty(val)) {
        result = val?.feedback?.map((id: string) => {
          const matchedItem = val?.list?.find(
            (item: { id: string; }) => item?.id === id,
          );
          return {
            type_id: matchedItem?.id,
            type_name: matchedItem?.text,
          };
        });
        otherParams = {
          feedback: result,
          feedback_content: val?.feedbackContent,
        };
      }

      const value = likeState === 2 ? 0 : -1;
      updateLikeState(value, otherParams);
      setLikeState(value === -1 ? 2 : 0);
      setFeedbackPopClose();
    });

    // 更新点赞点踩
    const updateLikeState = (like?: number, othersParams?: any) => {
      const params = {
        openId: userInfo?.openid,
        traceId: uuidv4(),
        sessionId,
        messageId,
        data: {
          like,
          ...othersParams,
        },
      };
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      updateHistory(params, showErrorTips);
      buriedBtnPoint({
        pageId: '700501',
        buttonId: '700501010',
        extInfo: JSON.stringify({
          sessionId,
          like,
          messageId,
          message: question,
          from: 'iwiki',
        }),
        typeId: 'aigc',
      });
    };
    // 复制事件
    const handleCopy = async () => {
      const textAnswer = answer?.filter(
        (item: { type: string; }) => item?.type === 'text',
      );
      const text =
        textAnswer?.map((item: { value: any; }) => item?.value)?.join('\n') ||
        '';
      // 过滤掉图片信息
      const regex1 = /<databrain_data>[\s\S]*?<\/databrain_data>\s*\n?/g;
      const regex2 = /<databraindata>[\s\S]*?<\/databraindata>\s*\n?/g;
      const filteredText = text.replace(regex1, '').replace(regex2, '');
      const status = await copyToClipboard(filteredText);
      if (status) {
        message.success({
          content: '已复制到粘贴板',
        });
      }
      console.log(status);
    };
    // 重试事件
    const handleRetry = () => {
      handleRefreshConfirm();
      // .then(() => {
      //   sendIWikiMessage?.({
      //     type: 'retrySession',
      //     payload: { msgId: uuidv4() },
      //   });
      // });
    };

    // 点赞事件
    const handleLike = () => {
      const value = likeState === 1 ? 0 : 1;
      updateLikeState(value);
      setLikeState(value);
    };

    // 点踩事件
    const handleDislike = () => {
      const value = likeState === 2 ? 0 : -1;
      if (value === 0) {
        updateLikeState(0);
        setLikeState(0);
        return;
      }
      setTrue();
    };

    return (
      <>
        <div className="dba-iwiki-feed">
          <div className="dba-iwiki-feed-img">
            <Popover placement="top-start" overlay={<div style={{background: '#242424', position: 'relative', top: '5px', left: '-5px', color: '#fff', padding: '4px 8px', fontSize: '14px', borderRadius: '5px' }}>复制</div>}>
              <img src={IwikiBtn} alt="" onClick={handleCopy} />
            </Popover>
            {isLastQA && (
              <Popover placement="top-start" overlay={<div style={{background: '#242424', position: 'relative', top: '5px', left: '-15px', color: '#fff', padding: '4px 8px', fontSize: '14px', borderRadius: '5px' }}>重新生成</div>}>
                <img src={IwikiRefresh} alt="" onClick={handleRetry} />
              </Popover>
            )}
          </div>
          <div className="dba-iwiki-feed-question">
            <div>答案是否解决你的问题</div>
            <span
              onClick={handleLike}
              className={classNames({
                'dba-iwiki-feed-question-active': likeState === 1,
              })}
            >
              是
            </span>
            <span
              className={classNames({
                'dba-iwiki-feed-question-active': likeState === 2,
              })}
              onClick={handleDislike}
            >
              否
            </span>
          </div>
        </div>
        <IWikiFeedbackPopConfirm
          {...{
            visible: feedbackPopState,
            onClose: () => {
              setFeedbackPopClose();
              // handleDislikeFeedback();
            },
            onConfirm: handleDislikeFeedback,
            title: '您觉得什么让您不满意？',
            messageList: FEED_BACK_MESSAGES_LIST?.slice(0, 4),
          }}
        />
      </>
    );
  },
);

export default memo(IWikiSingleQA);
